<oaibox-stats-card
  title="Notes"
  icon="fa-solid fa-message-lines"
  gradient="primary"
  [description]="order.title"
>
  <ol #notesList class="order-notes-list">
    @for (note of notes; track note.id) {
      <li class="order-note">
        <header>
          <span class="order-note-avatar">{{ note.username | initials }}</span>
          <span class="order-note-username">{{ note.username }}</span>
          <time class="order-note-timestamp" [dateTime]="note.timestamp">
            {{ note.timestamp | date: "dd/MM/yyyy HH:mm" }}
          </time>
        </header>
        <p class="order-note-message">{{ note.message }}</p>
      </li>
    } @empty {
      <li class="order-notes-empty">
        <strong class="text-muted fs-5">No Notes</strong>
      </li>
    }
  </ol>

  <oaibox-form [formGroup]="noteForm" (formSubmit)="addNote()">
    <label for="order-note-message" class="visually-hidden">New note</label>
    <textarea
      id="order-note-message"
      class="form-control"
      rows="3"
      [maxLength]="MESSAGE_MAX_LENGTH"
      [formControl]="noteForm.controls.message"
      placeholder="e.g. waiting on a part, customer asked to delay delivery…"
    ></textarea>

    <footer class="order-note-form-footer">
      <button
        type="submit"
        class="btn btn-success order-note-submit"
        [disabled]="noteForm.invalid || isSaving"
      >
        <i class="fa-solid fa-paper-plane"></i>
        Add Note
      </button>
    </footer>
  </oaibox-form>
</oaibox-stats-card>
